module.exports = __webpack_public_path__ + "img/yinsi.b5c98d0.png";